import { defineComponent as _defineComponent } from 'vue'
import { parseDecimal } from '@/utils/string';
import { onMounted, ref } from 'vue';

import { SdsProduct } from '@/interfaces/model/general/sds';

import {
  getSection8ACGIHCateoryList,
  getSection8ACGIHPropertyList,
} from '@/lib/formItem';
import { isFloatOrNull } from '@/lib/rule';
import { VForm } from 'vuetify/lib/components';
import sharedMessages from '@/lib/shared-messages';

type Props = {
  isEditing: boolean;
  isValid: boolean;
  categoryId: number;
  propertyId: number;
  concentration: number | null;
  concentrationUnit: string;
  concentrationNote: string;
  amount: number | null;
  amountUnit: string;
  amountNote: string;
  other: string;
  products: SdsProduct[];
};

export default /*#__PURE__*/_defineComponent({
  __name: 'SdsSection8ACGIHForm',
  props: {
    isEditing: { type: Boolean },
    isValid: { type: Boolean },
    categoryId: null,
    propertyId: null,
    concentration: null,
    concentrationUnit: null,
    concentrationNote: null,
    amount: null,
    amountUnit: null,
    amountNote: null,
    other: null,
    products: null
  },
  emits: ["update:isValid", "update:categoryId", "update:propertyId", "update:concentration", "update:concentrationUnit", "update:concentrationNote", "update:amount", "update:amountUnit", "update:amountNote", "update:other"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'update:isValid', data: boolean): void;
  (e: 'update:categoryId', data: number): void;
  (e: 'update:propertyId', data: number): void;
  (e: 'update:concentration', data: number | null): void;
  (e: 'update:concentrationUnit', data: string): void;
  (e: 'update:concentrationNote', data: string): void;
  (e: 'update:amount', data: number | null): void;
  (e: 'update:amountUnit', data: string): void;
  (e: 'update:amountNote', data: string): void;
  (e: 'update:other', data: string): void;
}), expose: any, slots: any, attrs: any }) {



const form = ref<InstanceType<typeof VForm> | null>(null);



const updateIsValid = (e: boolean): void => {
  emits('update:isValid', e);
};

const updatePropertyId = (e: number): void => {
  emits('update:propertyId', e);
};

const updateCategoryId = (e: number): void => {
  emits('update:categoryId', e);
};

const updateConcentration = (e: string | null): void => {
  emits('update:concentration', parseDecimal(e));
};

const updateAmount = (e: string | null): void => {
  emits('update:amount', parseDecimal(e));
};

const updateOther = (e: string): void => {
  emits('update:other', e);
};

onMounted((): void => {
  if (form.value) {
    form.value.validate();
  }
});

return { __sfc: true,form, emits, updateIsValid, updatePropertyId, updateCategoryId, updateConcentration, updateAmount, updateOther, getSection8ACGIHCateoryList, getSection8ACGIHPropertyList, isFloatOrNull, VForm, sharedMessages }
}

})